import React from 'react';
import { Oval } from 'react-loader-spinner';
import { zoomMapToBBOX } from '../Utils/MapUtils';
import Tabs from '@mui/material/Tabs';
import { styled } from '@mui/material/styles';

import Tab from '@mui/material/Tab';

import {
  Table,
  TableTitle,
  TableContent,
  TableRow,
  TableWrapper,
  TableRowTitle,
  TableSort,
  OvalContainer,
  TableNextPrevButton,
  TableFooterWrapper,
  TableFooterOpenFilter,
  TableTabWrapper,
  TableTabBar,
  TableNoResults,
  TableNoResultsOpenFiltre,
  TableMobileCard,
  TableMobilePair,
  TableMobileKey,
  TableMobileValue,
  TableTabCloseBtn,
  AccionsWrapper,
  AccionsTitle,
  TableGoToFilter,
  TableMobilePaginationWrapper,
  TableMobileFooterInfo,
  TablePaginationWrapper,
  TabSelector,
  TabSelectedTitle,
  TabOptionsContainer,
  TabOptionWrapper,
  TabOptionTitle,
  TabSelectorWrapper,
  TableGoToFeature
} from './TaulaCapaElement';
import { getTranslatedKey } from '../Utils/TranslateUtils';
import { checkDate, checkUrl, replaceHTTPWithHTTPS, urlNameSelector } from '../Utils/FormatUtils';
import { Link, SVGNewTab } from '../InformacioDePunt/InformacioPuntCardElement';
import { getAtributsTaula, orderByProperties } from '../Llegenda/CapaLlegenda/CapaLlegendaFooter/Components/Taula/TaulaUtils';

const StyledTab = styled(Tab)({
  maxWidth: 'none',
  padding: '0px 10px',
  minHeight: 0,
  textTransform: 'none',
  // borderBottom: '2px solid white',

  fontFamily: 'Open Sans, sans-serif',
  fill: 'white',
  '&.Mui-selected': {
    color: '#febf00',
    fill: '#febf00'
  }
});

const StyledTabs = styled(Tabs)(({ windowWidth }) => ({
  fontFamily: 'Open-sans',
  display: 'flex',
  '&.MuiTabs-root': {
    minHeight: '0',
    height: windowWidth > 768 ? '30px' : '40px'
  }
}));

export default class TaulaCapa extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sortDirection: {},
      selectorOptions: false,
      scroll: 0
    };
  }

  changePage = (action, canUse) => {
    if (canUse) {
      let layerTitle = this.props.taulaLayer.getTitle();
      let propsPage = this.props.taulaPage[layerTitle] === undefined ? 0 : this.props.taulaPage[layerTitle];
      let page;
      if (action === 'prev') {
        page = propsPage - 1;
      } else if (action === 'next') {
        page = propsPage + 1;
      } else if (action === 'init') {
        page = 0;
      } else {
        this.props.taulaArray % 20 === 0
          ? (page = this.props.taulaTotal[layerTitle] / 20 - 1)
          : (page = Math.floor(this.props.taulaTotal[layerTitle] / 20));
      }
      if (this.props.taulaLayer.isTemporal()) {
        this.props.getExternTable(this.props.taulaLayer, page);
      } else {
        let bbox = this.props.taulaSpacialBbox[layerTitle];
        this.props.getTaulaArray(this.props.taulaLayer, page, this.props.taulaSorting[this.props.taulaLayer.getTitle()], bbox);
      }
      this.props.updateTablePage(page, this.props.taulaLayer);
    }
  };

  componentDidUpdate = (prevProps) => {
    if (
      prevProps.taulaLoading[this.props.taulaLayer.getTitle()] === true &&
      this.props.taulaLoading[this.props.taulaLayer.getTitle()] === undefined
    ) {
      if (
        this.props.taulaArray[this.props.taulaLayer.getTitle()] !== undefined &&
        this.props.taulaArray[this.props.taulaLayer.getTitle()].length > 0 &&
        window.innerWidth > 768
      ) {
        const taula = document.getElementById('taula-capa');
        taula.scrollLeft = this.state.scroll;
      }
    }
  };

  //Función para ordenar por propiedad
  sorting = (property) => {
    const title = this.props.taulaLayer.getTitle();

    let sortDirection = this.props.taulaSorting[title] || {};
    sortDirection[property] = sortDirection[property] === 'asc' ? 'desc' : sortDirection[property] === 'desc' ? '' : 'asc';
    if (sortDirection[property] === '') {
      delete sortDirection[property];
    }
    this.props.setTaulaSorting(sortDirection, this.props.taulaLayer);

    let bbox = this.props.taulaSpacialBbox[title];
    this.props.getTaulaArray(this.props.taulaLayer, this.props.taulaPage[title] || 0, sortDirection, bbox);
  };

  //función para ir a la feature
  goToFeature = (i, title) => {
    let extent = this.props.taulaFc[title][i].getGeometry().getExtent();
    zoomMapToBBOX(this.props.map, extent, this.props.alturaInfoPunt, false);
    this.props.featureOverlay.getSource().clear();
    this.props.featureOverlay.getSource().addFeature(this.props.taulaFc[title][i]);
    this.setState({});
  };

  highlightFeature = (i, title) => {
    this.props.featureOverlay.getSource().clear();
    this.props.featureOverlay.getSource().addFeature(this.props.taulaFc[title][i]);
    this.setState({});
  };

  highlightRow = (i, title) => {
    return this.props.taulaFc[title][i] === this.props.featureOverlay.getSource().getFeatures()[0];
  };

  handleObrirFiltre = () => {
    this.props.arrayLayers.forEach((layer) => {
      layer.setExpanded(false);
    });
    this.props.changeLlegendaOpen(true);
    this.props.taulaLayer.setExpanded('panel2');
    this.props.taulaLayer.setFiltresOpen(true);
    this.props.scrollToFiltre(this.props.taulaLayer);
  };

  handleScroll = (e) => {
    this.setState({ scroll: e.target.scrollLeft });
  };

  totalFormat = (total) => {
    return total?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  };

  // Función para crear la tabla de capa
  createTable = (layer) => {
    let layerTitle = layer.getTitle();
    let count = 0;
    let page = this.props.taulaPage[layerTitle] === undefined ? 0 : this.props.taulaPage[layerTitle];
    return (
      <>
        <TableTabWrapper>
          {this.renderTabs()}
          <TableTabBar />
        </TableTabWrapper>
        {this.props.taulaLoading[layerTitle] === true ? (
          <OvalContainer height={this.props.alturaInfoPunt} width={window.innerWidth}>
            <Oval
              height={window.innerHeight > 464 ? 80 : 40}
              width={window.innerHeight > 464 ? 80 : 40}
              color="#febf00"
              wrapperStyle={{}}
              wrapperClass=""
              visible={true}
              ariaLabel="oval-loading"
              secondaryColor="#ccc"
              strokeWidth={2}
              strokeWidthSecondary={2}
            />
          </OvalContainer>
        ) : this.props.taulaArray[layerTitle]?.length === 0 ? (
          <>
            <TableNoResults>
              {getTranslatedKey('taulaNoResult')}
              {!this.props.taulaLayer.isTemporal() && (
                <TableNoResultsOpenFiltre onClick={() => this.handleObrirFiltre()}> {getTranslatedKey('taulaOpenFilter')} </TableNoResultsOpenFiltre>
              )}{' '}
            </TableNoResults>
          </>
        ) : this.props.taulaArray[layerTitle] ? (
          <>
            <TableWrapper altura={this.props.alturaInfoPunt} id="taula-capa" onScroll={(e) => this.handleScroll(e)}>
              <Table fontSizeEnabled={this.props.fontSizeEnabled}>
                <TableRowTitle>
                  <TableGoToFeature number={this.props.taulaArray[layerTitle].length}>
                    <AccionsWrapper>
                      <AccionsTitle>{getTranslatedKey('taulaGoTo')}</AccionsTitle>
                    </AccionsWrapper>
                  </TableGoToFeature>
                  {getAtributsTaula(this.props.taulaLayer.getProperties(), Object.keys(this.props.taulaArray[layerTitle][0])).map((property) => {
                    return (
                      <TableTitle
                        title={
                          this.props.taulaSorting[this.props.taulaLayer.getTitle()]?.[property.name] === 'asc'
                            ? getTranslatedKey('taulaDesc')
                            : this.props.taulaSorting[this.props.taulaLayer.getTitle()]?.[property.name] === 'desc'
                            ? getTranslatedKey('taulaStnd')
                            : getTranslatedKey('taulaAsc')
                        }
                        onClick={() => !this.props.taulaLayer.isTemporal() && this.sorting(property.name)}
                        number={this.props.taulaArray.length}>
                        {property.alias || property.name}
                        {!this.props.taulaLayer.isTemporal() && (
                          <TableSort>
                            {this.props.taulaSorting[this.props.taulaLayer.getTitle()]?.[property.name] === 'asc' ? (
                              <svg
                                title={getTranslatedKey('ascOrderTitle')}
                                xmlns="https://www.w3.org/2000/svg"
                                fill="white"
                                width="16"
                                version="1.1"
                                id="svg1711"
                                x="0px"
                                y="0px"
                                viewBox="0 0 682.7 682.7">
                                <path
                                  fill="#febf00"
                                  d="M188.2,678.4c-16.9,0-30.6-13.7-30.6-30.6V109l-70.1,70.4c-12,12-31.5,12-43.5,0s-12-31.5,0-43.5l0,0L166.5,13.4  c11.9-12,31.3-12.1,43.3-0.2c0.1,0.1,0.1,0.1,0.2,0.2l122.5,122.5c12,12,12,31.5,0,43.5c-12,12-31.5,12-43.5,0l0,0L218.8,109v538.8  C218.8,664.7,205.1,678.4,188.2,678.4z"
                                />
                                <path
                                  opacity={0.5}
                                  d="M490.5,676.7c-8.1,0-16-3.1-21.7-8.9L346.2,545.3c-12-12-12-31.5,0-43.5c12-12,31.5-12,43.5,0l70.1,70.4V33.5  c0-16.9,13.7-30.6,30.6-30.6s30.6,13.7,30.6,30.6v538.8l70.1-70.4c12-12,31.5-12,43.5,0c12,12,12,31.5,0,43.5L512.2,667.8  C506.5,673.5,498.6,676.7,490.5,676.7L490.5,676.7z"
                                />
                              </svg>
                            ) : this.props.taulaSorting[this.props.taulaLayer.getTitle()]?.[property.name] === 'desc' ? (
                              <svg
                                title={getTranslatedKey('stnOrderTitle')}
                                xmlns="https://www.w3.org/2000/svg"
                                version="1.1"
                                id="svg1711"
                                width="16"
                                fill="white"
                                x="0px"
                                y="0px"
                                viewBox="0 0 682.7 682.7">
                                <path
                                  opacity={0.5}
                                  d="M188.2,678.4c-16.9,0-30.6-13.7-30.6-30.6V109l-70.1,70.4c-12,12-31.5,12-43.5,0s-12-31.5,0-43.5l0,0  L166.5,13.4c11.9-12,31.3-12.1,43.3-0.2c0.1,0.1,0.1,0.1,0.2,0.2l122.5,122.5c12,12,12,31.5,0,43.5c-12,12-31.5,12-43.5,0l0,0  L218.8,109v538.8C218.8,664.7,205.1,678.4,188.2,678.4z"
                                />
                                <path
                                  fill="#febf00"
                                  d="M490.5,676.7c-8.1,0-16-3.1-21.7-8.9L346.2,545.3c-12-12-12-31.5,0-43.5c12-12,31.5-12,43.5,0l70.1,70.4V33.5  c0-16.9,13.7-30.6,30.6-30.6s30.6,13.7,30.6,30.6v538.8l70.1-70.4c12-12,31.5-12,43.5,0c12,12,12,31.5,0,43.5L512.2,667.8  C506.5,673.5,498.6,676.7,490.5,676.7L490.5,676.7z"
                                />
                              </svg>
                            ) : (
                              <svg
                                title={getTranslatedKey('descOrderTitle')}
                                xmlns="https://www.w3.org/2000/svg"
                                version="1.1"
                                id="svg1711"
                                fill="white"
                                width="16"
                                x="0px"
                                y="0px"
                                viewBox="0 0 682.7 682.7">
                                <path d="M188.2,678.4c-16.9,0-30.6-13.7-30.6-30.6V109l-70.1,70.4c-12,12-31.5,12-43.5,0s-12-31.5,0-43.5l0,0L166.5,13.4  c11.9-12,31.3-12.1,43.3-0.2c0.1,0.1,0.1,0.1,0.2,0.2l122.5,122.5c12,12,12,31.5,0,43.5c-12,12-31.5,12-43.5,0l0,0L218.8,109v538.8  C218.8,664.7,205.1,678.4,188.2,678.4z" />
                                <path d="M490.5,676.7c-8.1,0-16-3.1-21.7-8.9L346.2,545.3c-12-12-12-31.5,0-43.5c12-12,31.5-12,43.5,0l70.1,70.4V33.5  c0-16.9,13.7-30.6,30.6-30.6s30.6,13.7,30.6,30.6v538.8l70.1-70.4c12-12,31.5-12,43.5,0c12,12,12,31.5,0,43.5L512.2,667.8  C506.5,673.5,498.6,676.7,490.5,676.7L490.5,676.7z" />
                              </svg>
                            )}
                          </TableSort>
                        )}
                      </TableTitle>
                    );
                  })}

                  <TableGoToFilter>
                    {!this.props.taulaLayer.isTemporal() && (
                      <TableFooterOpenFilter
                        title={getTranslatedKey('taulaOpenFilter')}
                        hasFilter={
                          this.props.taulaFullFilter[this.props.taulaLayer.getTitle()] !== undefined &&
                          this.props.taulaFullFilter[this.props.taulaLayer.getTitle()] !== ''
                        }
                        onClick={() => this.handleObrirFiltre()}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          id="interface_essential_by_mad-lab_studio"
                          enable-background="new 0 0 24 24"
                          fill={
                            this.props.taulaFullFilter[this.props.taulaLayer.getTitle()] !== undefined &&
                            this.props.taulaFullFilter[this.props.taulaLayer.getTitle()] !== ''
                              ? '#febf00'
                              : 'white'
                          }
                          viewBox="0 0 24 24"
                          width="18">
                          <g>
                            <path d="m9 22.5c-.2 0-.4-.1-.5-.1-.3-.2-.5-.6-.5-.9v-9.6l-7.7-8.7c-.4-.4-.3-1 .1-1.4.1-.2.4-.3.6-.3h22c.6 0 1 .4 1 1 0 .2-.1.5-.2.7l-7.8 8.7v6.6c0 .4-.2.7-.6.9l-6 3c-.1.1-.2.1-.4.1zm-5.8-19 6.5 7.3c.2.2.3.5.3.7v8.4l4-2v-6.4c0-.2.1-.5.3-.7l6.5-7.3z"></path>
                          </g>
                        </svg>
                      </TableFooterOpenFilter>
                    )}
                  </TableGoToFilter>
                </TableRowTitle>
                {this.props.taulaArray[layerTitle].map((obj, i) => {
                  const properties = this.props.taulaLayer.getProperties();
                  if (properties) obj = orderByProperties(obj, properties);
                  const isHighLight = this.highlightRow(i, layerTitle);
                  count++;
                  return (
                    <TableRow count={count} isHighLight={isHighLight} className="table-row">
                      <TableContent
                        onMouseEnter={() => this.setState({ isGoToHover: i })}
                        onMouseLeave={() => this.setState({ isGoToHover: null })}
                        onClick={() => this.goToFeature(i, layerTitle)}
                        number={this.props.taulaArray[layerTitle].length}
                        className="go-to-button">
                        <TableNextPrevButton>
                          <svg
                            fill={window.innerWidth > 768 ? (this.state.isGoToHover === i ? '#febf00' : 'white') : 'white'}
                            xmlns="http://www.w3.org/2000/svg"
                            cursor="pointer"
                            viewBox="0 0 32 32"
                            width="24">
                            <path d="M28.5259,3.1494a1,1,0,0,0-.9732-.0439L20,6.8818,12.4473,3.1055a1.0008,1.0008,0,0,0-.8946,0l-8,4A1,1,0,0,0,3,8V28a1,1,0,0,0,1.4473.8945L12,25.1182l3.5527,1.7763a1,1,0,0,0,.8946-1.789L13,23.3818V8a1,1,0,0,0-2,0V23.3818l-6,3V8.6182l7-3.5,7,3.5V14a1,1,0,0,0,2,0V8.6182l6-3V18a1,1,0,0,0,2,0V4A1,1,0,0,0,28.5259,3.1494Z" />
                            <path d="M26.167,24.7529a5.015,5.015,0,1,0-1.4141,1.4141l2.54,2.54a1,1,0,0,0,1.414-1.414ZM19,22a3,3,0,1,1,3,3A3.0033,3.0033,0,0,1,19,22Z" />
                          </svg>
                        </TableNextPrevButton>
                      </TableContent>
                      {Object.keys(obj).map((key) => {
                        return (
                          <TableContent onClick={() => this.highlightFeature(i, layerTitle)} number={this.props.taulaArray[layerTitle].length}>
                            {checkUrl(obj[key]) ? (
                              <Link target="_blank" rel="noreferrer" href={replaceHTTPWithHTTPS(obj[key])}>
                                {urlNameSelector(obj[key])}
                                <SVGNewTab id="NewTab" enable-background="new 0 0 20 20" viewBox="0 0 20 20" fill="white">
                                  <g>
                                    <path d="m14 0v2h2.6l-8.3 8.3 1.4 1.4 8.3-8.3v2.6h2v-6z" />
                                    <path d="m16 18h-14v-14h9v-2h-11v18h18v-11h-2z" />
                                  </g>
                                </SVGNewTab>
                              </Link>
                            ) : checkDate(obj[key]) ? (
                              obj[key].substring(0, obj[key].length - 1)
                            ) : (
                              obj[key]
                            )}
                          </TableContent>
                        );
                      })}

                      <TableContent></TableContent>
                    </TableRow>
                  );
                })}
              </Table>
            </TableWrapper>
            {/* Paginación / Footer  */}
            <TableFooterWrapper fontSizeEnabled={this.props.fontSizeEnabled}>
              <TableMobileFooterInfo>
                {page * 20 + 1}-{page * 20 + 20 >= this.props.taulaTotal[layerTitle] ? this.props.taulaTotal[layerTitle] : page * 20 + 20}{' '}
                {getTranslatedKey('taulaPaginateOf')} {this.totalFormat(this.props.taulaTotal[layerTitle])}
              </TableMobileFooterInfo>
              <TablePaginationWrapper>
                <TableNextPrevButton enabled={page > 0} onClick={() => this.changePage('init', page > 0)}>
                  <svg
                    width="24px"
                    height="24px"
                    focusable="false"
                    fill={page > 0 ? 'white' : 'gray'}
                    aria-hidden="true"
                    viewBox="0 0 24 24"
                    data-testid="FirstPageIcon">
                    <path d="M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"></path>
                  </svg>
                </TableNextPrevButton>
                <TableNextPrevButton enabled={page > 0} onClick={() => this.changePage('prev', page > 0)}>
                  {' '}
                  <svg
                    width="24px"
                    height="24px"
                    fill={page > 0 ? 'white' : 'gray'}
                    focusable="false"
                    aria-hidden="true"
                    viewBox="0 0 24 24"
                    data-testid="KeyboardArrowRightIcon">
                    <path d="M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"></path>
                  </svg>
                </TableNextPrevButton>
                <TableNextPrevButton
                  enabled={!(page * 20 + 20 >= this.props.taulaTotal[layerTitle])}
                  onClick={() => this.changePage('next', !(page * 20 + 20 >= this.props.taulaTotal[layerTitle]))}>
                  <svg
                    width="24px"
                    height="24px"
                    fill={page * 20 + 20 >= this.props.taulaTotal[layerTitle] ? 'gray' : 'white'}
                    focusable="false"
                    aria-hidden="true"
                    viewBox="0 0 24 24"
                    data-testid="KeyboardArrowRightIcon">
                    <path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"></path>
                  </svg>
                </TableNextPrevButton>
                <TableNextPrevButton
                  enabled={!(page * 20 + 20 >= this.props.taulaTotal[layerTitle])}
                  onClick={() => this.changePage('last', !(page * 20 + 20 >= this.props.taulaTotal[layerTitle]))}>
                  <svg
                    width="24px"
                    height="24px"
                    fill={page * 20 + 20 >= this.props.taulaTotal[layerTitle] ? 'gray' : 'white'}
                    focusable="false"
                    aria-hidden="true"
                    viewBox="0 0 24 24"
                    data-testid="LastPageIcon">
                    <path d="M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"></path>
                  </svg>
                </TableNextPrevButton>
              </TablePaginationWrapper>
            </TableFooterWrapper>
          </>
        ) : null}
      </>
    );
  };

  createMobileTable = (layer) => {
    let layerTitle = layer.getTitle();
    let page = this.props.taulaPage[layerTitle] === undefined ? 0 : this.props.taulaPage[layerTitle];

    return (
      <>
        {this.renderSelector()}
        {this.props.taulaLoading[layerTitle] === true ? (
          <OvalContainer height={this.props.alturaInfoPunt} width={window.innerWidth}>
            <Oval
              height={window.innerHeight > 400 ? 120 : 40}
              width={window.innerHeight > 400 ? 120 : 40}
              color="#febf00"
              wrapperStyle={{}}
              wrapperClass=""
              visible={true}
              ariaLabel="oval-loading"
              secondaryColor="#ccc"
              strokeWidth={2}
              strokeWidthSecondary={2}
            />
          </OvalContainer>
        ) : this.props.taulaArray[layerTitle].length === 0 ? (
          <>
            <TableNoResults>
              {getTranslatedKey('taulaNoResult')}
              {!this.props.taulaLayer.isTemporal() && (
                <TableNoResultsOpenFiltre onClick={() => this.handleObrirFiltre()}> {getTranslatedKey('taulaOpenFilter')} </TableNoResultsOpenFiltre>
              )}{' '}
            </TableNoResults>
          </>
        ) : (
          <>
            <TableWrapper altura={this.props.alturaInfoPunt} isMobile>
              {this.props.taulaArray[layerTitle].map((obj, i) => {
                const isHighLight = this.highlightRow(i, layerTitle);
                return (
                  <TableMobileCard isHighLight={isHighLight} onClick={() => this.highlightFeature(i, layerTitle)}>
                    {Object.entries(obj).map(([key, value]) => {
                      return (
                        <TableMobilePair fontSizeEnabled={this.props.fontSizeEnabled}>
                          <TableMobileKey fontSizeEnabled={this.props.fontSizeEnabled}>{key}: </TableMobileKey>
                          <TableMobileValue fontSizeEnabled={this.props.fontSizeEnabled}>{value}</TableMobileValue>
                        </TableMobilePair>
                      );
                    })}
                    <TableMobilePair>
                      <TableMobileKey>
                        <>{getTranslatedKey('taulaGoTo')} </>
                      </TableMobileKey>
                      <TableMobileValue onClick={() => this.goToFeature(i, layerTitle)}>
                        <svg fill="white" xmlns="http://www.w3.org/2000/svg" cursor="pointer" viewBox="0 0 32 32" width="20">
                          <path d="M28.5259,3.1494a1,1,0,0,0-.9732-.0439L20,6.8818,12.4473,3.1055a1.0008,1.0008,0,0,0-.8946,0l-8,4A1,1,0,0,0,3,8V28a1,1,0,0,0,1.4473.8945L12,25.1182l3.5527,1.7763a1,1,0,0,0,.8946-1.789L13,23.3818V8a1,1,0,0,0-2,0V23.3818l-6,3V8.6182l7-3.5,7,3.5V14a1,1,0,0,0,2,0V8.6182l6-3V18a1,1,0,0,0,2,0V4A1,1,0,0,0,28.5259,3.1494Z" />
                          <path d="M26.167,24.7529a5.015,5.015,0,1,0-1.4141,1.4141l2.54,2.54a1,1,0,0,0,1.414-1.414ZM19,22a3,3,0,1,1,3,3A3.0033,3.0033,0,0,1,19,22Z" />
                        </svg>
                      </TableMobileValue>
                    </TableMobilePair>
                  </TableMobileCard>
                );
              })}
            </TableWrapper>
            <TableFooterWrapper isMobile>
              <TableMobileFooterInfo>
                {page * 20 + 1}-{page * 20 + 20 >= this.props.taulaTotal[layerTitle] ? this.props.taulaTotal[layerTitle] : page * 20 + 20}{' '}
                {getTranslatedKey('taulaPaginateOf')} {this.totalFormat(this.props.taulaTotal[layerTitle])}
              </TableMobileFooterInfo>
              <TableMobilePaginationWrapper>
                <TableNextPrevButton enabled={page > 0} onClick={() => this.changePage('init', page > 0)}>
                  <svg
                    width="24px"
                    height="24px"
                    focusable="false"
                    fill={page > 0 ? 'white' : 'gray'}
                    aria-hidden="true"
                    viewBox="0 0 24 24"
                    data-testid="FirstPageIcon">
                    <path d="M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"></path>
                  </svg>
                </TableNextPrevButton>
                <TableNextPrevButton enabled={page > 0} onClick={() => this.changePage('prev', page > 0)}>
                  {' '}
                  <svg
                    width="24px"
                    height="24px"
                    fill={page > 0 ? 'white' : 'gray'}
                    focusable="false"
                    aria-hidden="true"
                    viewBox="0 0 24 24"
                    data-testid="KeyboardArrowRightIcon">
                    <path d="M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"></path>
                  </svg>
                </TableNextPrevButton>
                <TableNextPrevButton
                  enabled={page * 20 + 20 >= this.props.taulaTotal[layerTitle]}
                  onClick={() => this.changePage('next', !(page * 20 + 20 >= this.props.taulaTotal[layerTitle]))}>
                  <svg
                    width="24px"
                    height="24px"
                    fill={page * 20 + 20 >= this.props.taulaTotal[layerTitle] ? 'gray' : 'white'}
                    focusable="false"
                    aria-hidden="true"
                    viewBox="0 0 24 24"
                    data-testid="KeyboardArrowRightIcon">
                    <path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"></path>
                  </svg>
                </TableNextPrevButton>
                <TableNextPrevButton
                  enabled={page * 20 + 20 >= this.props.taulaTotal[layerTitle]}
                  onClick={() => this.changePage('last', !(page * 20 + 20 >= this.props.taulaTotal[layerTitle]))}>
                  <svg
                    width="24px"
                    height="24px"
                    fill={page * 20 + 20 >= this.props.taulaTotal[layerTitle] ? 'gray' : 'white'}
                    focusable="false"
                    aria-hidden="true"
                    viewBox="0 0 24 24"
                    data-testid="LastPageIcon">
                    <path d="M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"></path>
                  </svg>
                </TableNextPrevButton>
              </TableMobilePaginationWrapper>
            </TableFooterWrapper>
          </>
        )}
      </>
    );
  };

  renderTabs = () => {
    let keysArr = Object.keys(this.props.taulaArray);
    return (
      <StyledTabs
        windowWidth={window.innerWidth}
        variant={keysArr.length > 1 ? 'scrollable' : null}
        scrollButtons="auto"
        value={this.props.taulaLayer.getTitle()}
        TabScrollButtonProps={{
          style: {
            color: 'white'
          }
        }}
        TabIndicatorProps={{
          style: {
            backgroundColor: '#febf00',
            height: 4,
            zIndex: 1
          }
        }}>
        {keysArr.map((key) => (
          <StyledTab
            disableRipple
            sx={{ color: 'white' }}
            value={key}
            onClick={() => this.handleTabClick(key)}
            label={
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {/* Dades de  */}
                {key}{' '}
                {keysArr.length !== 1 && (
                  <TableTabCloseBtn onClick={(e) => this.handleCloseTab(key, e)}>
                    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" version="1.1" x="0px" y="0px" width="18" height="18">
                      <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"></path>
                    </svg>
                  </TableTabCloseBtn>
                )}
              </div>
            }></StyledTab>
        ))}
      </StyledTabs>
    );
  };

  renderSelector = () => {
    let keysArr = Object.keys(this.props.taulaArray);
    return (
      <TabSelectorWrapper>
        <TabSelector onClick={() => this.setState({ selectorOptions: !this.state.selectorOptions })}>
          <TabSelectedTitle fontSizeEnabled={this.props.fontSizeEnabled}>{this.props.taulaLayer.getTitle()}</TabSelectedTitle>
          {keysArr.length > 1 && (
            <svg focusable="false" aria-hidden="true" width="24" fill="white" viewBox="0 0 24 24" data-testid="ExpandMoreIcon">
              <path d="M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"></path>
            </svg>
          )}
        </TabSelector>
        {this.state.selectorOptions && keysArr.length > 1 && (
          <TabOptionsContainer>
            {keysArr.map((key) => {
              return (
                <TabOptionWrapper>
                  <TabOptionTitle fontSizeEnabled={this.props.fontSizeEnabled} onClick={() => this.handleTabClick(key)}>
                    {key}
                  </TabOptionTitle>
                  <svg
                    onClick={(e) => this.handleCloseTab(key, e)}
                    viewBox="0 0 24 24"
                    fill="#fff"
                    xmlns="http://www.w3.org/2000/svg"
                    version="1.1"
                    x="0px"
                    y="0px"
                    width="18"
                    height="18"
                    class="sc-exNKxI">
                    <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"></path>
                  </svg>
                </TabOptionWrapper>
              );
            })}
          </TabOptionsContainer>
        )}
        {!this.props.taulaLayer.isTemporal() && (
          <TableFooterOpenFilter title={getTranslatedKey('taulaOpenFilter')} onClick={() => this.handleObrirFiltre()}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              id="interface_essential_by_mad-lab_studio"
              enable-background="new 0 0 24 24"
              fill={
                this.props.taulaFullFilter[this.props.taulaLayer.getTitle()] !== undefined &&
                this.props.taulaFullFilter[this.props.taulaLayer.getTitle()] !== ''
                  ? '#febf00'
                  : 'white'
              }
              viewBox="0 0 24 24"
              width="18">
              <g>
                <path d="m9 22.5c-.2 0-.4-.1-.5-.1-.3-.2-.5-.6-.5-.9v-9.6l-7.7-8.7c-.4-.4-.3-1 .1-1.4.1-.2.4-.3.6-.3h22c.6 0 1 .4 1 1 0 .2-.1.5-.2.7l-7.8 8.7v6.6c0 .4-.2.7-.6.9l-6 3c-.1.1-.2.1-.4.1zm-5.8-19 6.5 7.3c.2.2.3.5.3.7v8.4l4-2v-6.4c0-.2.1-.5.3-.7l6.5-7.3z"></path>
              </g>
            </svg>
          </TableFooterOpenFilter>
        )}
      </TabSelectorWrapper>
    );
  };

  handleTabClick = (title) => {
    this.props.arrayLayers.forEach((layer) => {
      if (layer.getTitle() === title) {
        this.props.setTaulaLayer(layer);
      }
    });
    this.setState({ selectorOptions: false });
  };

  handleCloseTab = (title, e) => {
    e.stopPropagation();
    this.props.arrayLayers.forEach((layer) => {
      if (layer.getTitle() === title) {
        this.props.deleteTaula(layer, true);
      }
    });
  };

  render() {
    return <>{window.innerWidth > 768 ? this.createTable(this.props.taulaLayer) : this.createMobileTable(this.props.taulaLayer)}</>;
  }
}
